import { ApiClient } from '../../../shared/api/ApiClient';

export interface TntSettings {
  apiBaseUrl: string;
  account: string;
  senderCode: string;
  prefix: string;
  username: string;
}

export interface TntTestResult {
  success: boolean;
  message: string;
  durationMs: number;
  response?: unknown;
}

export function getTntSettings(api: ApiClient): Promise<TntSettings> {
  return api.get<TntSettings>('/admin/api/tnt/settings');
}

export function testTntConnection(api: ApiClient): Promise<TntTestResult> {
  return api.post<TntTestResult>('/admin/api/tnt/test');
}
